import optimizely, { Client, OptimizelyUserContext } from '@optimizely/optimizely-sdk'
import { setOptimizelyExperiment } from 'actions/SystemActions'

import config from 'constants/config'
import { AppStore } from '../../store'
import { OptimizelyEvent } from './events'
import type { OptimizelyExperiments } from 'lib/optimizely'

let client: Client | null
export let userContext: OptimizelyUserContext
export let isReady = false

export const preloaders: OptimizelyExperiments[] = []
function getClient() {
  if (!client) {
    client = optimizely.createInstance({
      sdkKey: config.OPTIMIZELY_SDK_KEY,
      eventBatchSize: 10,
      eventFlushInterval: 1000,
    })
  }

  return client
}

/**
 * Event tracking function
*/
export async function track(event: OptimizelyEvent) {
  const { eventName, tags } = event

  if (!userContext) return

  try {
    userContext.trackEvent(eventName, tags)
  } catch (error) {
    console.error(error)
  }
}

/**
 * Init function
*/
export async function init(userId: string, attributes: Record<string, any>, store: AppStore) {
  const optimizelyClient = getClient()!

  optimizelyClient.onReady().then((result) => {
    if (result.success) {
      isReady = true
      preloaders.forEach(flagKey => { store.dispatch(setOptimizelyExperiment(flagKey)) })
    }
  })

  if (!optimizelyClient) {
    return {}
  }

  userContext = optimizelyClient.createUserContext(userId, attributes)!
  optimizely.setLogger(null) // comment this line to see info logs in the browser console
}
